import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Contact form submission
export const submitContactForm = async (formData) => {
  try {
    const response = await api.post('/contact', formData);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error || 'Failed to send message. Please try again.'
    );
  }
};

// Newsletter subscription
export const subscribeNewsletter = async (email) => {
  try {
    const response = await api.post('/newsletter', { email });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error || 'Failed to subscribe. Please try again.'
    );
  }
};

// Health check
export const checkApiHealth = async () => {
  try {
    const response = await api.get('/health');
    return response.data;
  } catch (error) {
    console.error('API health check failed:', error);
    return { status: 'error' };
  }
};

export default api;
